module.exports = fox => {
    'use strict';

    fox.registerWidget('Payment_Form_Paxum', {
        configure: function() {
            this.registerOptions('', {
                template: 'payment_form_paxum',
                // 'widgets.form': {
                //     elements: {

                //     }
                // }
            });
            
            this.callParent('configure', arguments);
        },
    }, 'Base_Payment_Form');
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/account/forms/paxum.es.js